import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

// Clients & Access (/elements/setup), the client page (/elements/clients/:id)
// and Access (beta) were retired into Access (FORGE-411 phase 9, Brennan
// 2026-10-29). Old links and bookmarks land on the same place in Access.

export const ACCESS = "/elements/access";

// the old Setup tabs -> Access views
const VIEW: Record<string, string> = {
  platforms: "modules",
  projects: "projects",
  contracts: "contracts",
};
const KEEP = [
  "view",
  "group",
  "tab",
  "client",
  "person",
  "finding",
  "client_id",
];

export function accessUrl(search: string): string {
  const old = new URLSearchParams(search);
  const next = new URLSearchParams();
  for (const k of KEEP) {
    const v = old.get(k);
    if (v) next.set(k, k === "view" ? (VIEW[v] ?? v) : v);
  }
  // a project link (?project=<id>) opens the Projects view
  if (old.get("project") && !next.get("view")) next.set("view", "projects");
  const q = next.toString();
  return q ? `${ACCESS}?${q}` : ACCESS;
}

export function ToAccess() {
  const { search } = useLocation();
  return <Navigate to={accessUrl(search)} replace />;
}

export function ClientToAccess() {
  const { id } = useParams();
  return (
    <Navigate
      to={id ? `${ACCESS}?client_id=${encodeURIComponent(id)}` : ACCESS}
      replace
    />
  );
}
